/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Subtitle export finished successfully" |
*
* @param {Subtitle_Export_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_complete_toast = /** @type {((inputs?: Subtitle_Export_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'exportation des sous-titres s'est terminée avec succès.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Export der Untertitel wurde erfolgreich abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione dei sottotitoli completata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт субтитров успешно завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La exportación de subtítulos finalizó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕导出已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕のエクスポートが正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक निर्यात सफलतापूर्वक पूरा हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação de legendas concluída com sucesso.")
	return /** @type {LocalizedString} */ ("Subtitle export finished successfully")
});